import { useCallback, useEffect, useState } from "react";
import { request } from "./../../httpClient/request";

export const useGetAchievment = (user_id?: string) => {
  const [loading, setLoading] = useState<boolean>(false);

  const [received, setReceived] = useState([]);
  const [unreceived, setUnreceived] = useState([]);

  const getAchievment = useCallback(async (user_id?: string) => {
    setReceived([]);
    setUnreceived([]);
    setLoading(true);
    const [achievment, achievmentCollection] = await Promise.all([
      request({
        path: "achievment/list",
      }),
      request({
        path: user_id
          ? `achievment-collection/list?user_id=${user_id}`
          : "achievment-collection/list",
      }),
    ]);
    let achieveData = achievment.data;
    achievmentCollection.data.forEach((collection) => {
      let currentAchievement = achieveData.find(
        (achieve) => achieve.id === +collection.achievment_id
      );
      let currentAchievementIndex = achieveData.findIndex(
        (achieve) => achieve.id === +collection.achievment_id
      );
      if (currentAchievement) {
        console.log("currentAchievement", currentAchievement);
        setReceived((prev) => [...prev, currentAchievement]);
        achievment.data.splice(currentAchievementIndex, 1);
      }
    });
    setUnreceived((prev) => [...prev, ...achieveData]);
    setLoading(false);
  }, []);

  const addAchievment = useCallback(async (values) => {
    setLoading(true);
    const res = await request({
      path: "achievment-collection/add",
      method: "POST",
      body: JSON.stringify(values),
    });
    setLoading(false);
    await getAchievment();
    return res.data;
  }, []);

  useEffect(() => {
    getAchievment(user_id);
  }, []);

  return {
    received,
    unreceived,
    getAchievment,
    loading,
    addAchievment,
  };
};
